import { Center, Stack, Text, ThemeIcon } from '@mantine/core';
import { IconCalendarEvent } from '@tabler/icons-react';

const AvailabilityCalendarEmpty: React.FC = () => (
  <Center h="100%" mih={400}>
    <Stack align="center" gap="md">
      <ThemeIcon size="xl" variant="light" color="gray">
        <IconCalendarEvent size={28} />
      </ThemeIcon>
      <Text c="dimmed" size="sm">
        Select a restaurant to manage availability
      </Text>
    </Stack>
  </Center>
);

export default AvailabilityCalendarEmpty;
